import jsPDF from "jspdf";
import "jspdf-autotable";
import axisInvoice from "../../Assets/pdfImgaes/axisInvoice.jpg";

export function isAxisBank(billTo = {}) {
  const name = (billTo?.company || billTo?.name || "").toLowerCase().trim();
  return name.includes("axis bank");
}

const ones = [
  "",
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine",
  "Ten",
  "Eleven",
  "Twelve",
  "Thirteen",
  "Fourteen",
  "Fifteen",
  "Sixteen",
  "Seventeen",
  "Eighteen",
  "Nineteen",
];
const tensArr = [
  "",
  "",
  "Twenty",
  "Thirty",
  "Forty",
  "Fifty",
  "Sixty",
  "Seventy",
  "Eighty",
  "Ninety",
];

function numToWords(n) {
  n = Math.round(n);
  if (n === 0) return "Zero";
  if (n < 0) return "Minus " + numToWords(-n);
  if (n < 20) return ones[n];
  if (n < 100)
    return tensArr[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
  if (n < 1000)
    return (
      ones[Math.floor(n / 100)] +
      " Hundred" +
      (n % 100 ? " " + numToWords(n % 100) : "")
    );
  if (n < 100000)
    return (
      numToWords(Math.floor(n / 1000)) +
      " Thousand" +
      (n % 1000 ? " " + numToWords(n % 1000) : "")
    );
  if (n < 10000000)
    return (
      numToWords(Math.floor(n / 100000)) +
      " Lakh" +
      (n % 100000 ? " " + numToWords(n % 100000) : "")
    );
  return (
    numToWords(Math.floor(n / 10000000)) +
    " Crore" +
    (n % 10000000 ? " " + numToWords(n % 10000000) : "")
  );
}

function fmt(n) {
  return Number(n || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function formatDate(d) {
  if (!d) return "";
  const date = new Date(d);
  if (isNaN(date.getTime())) return String(d);
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function generateOtherInvoicePDF(invoiceData) {
  const {
    invoiceNumber = "",
    date = "",
    pan = "",
    gstNumber = "",
    cgstRate = 2.5,
    sgstRate = 2.5,
    cgstAmount = 0,
    sgstAmount = 0,
    subTotal = 0,
    discountAmount = 0,
    totalAmount = 0,
    amountInWords = "",
    billTo = {},
    items = [],
    selectedBank = null,
    selectedQuery = null,
    company = {},
    splitBillAttached = false,
    advertisingType = "",
    axisBankDetails = {},
  } = invoiceData;

  const axisTotal = axisBankDetails?.totalAmount;
  const amtWords = numToWords(Math.round(axisTotal)) + " Only";

  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  const pageW = 210;
  const pageH = 297;
  const marginL = 14;

  doc.addImage(axisInvoice, "JPG", 0, 0, pageW, pageH);

  const BLACK = [20, 20, 20];
  const DARK_BLUE = [0, 51, 102];
  const RED = [200, 16, 46];
  const TEAL = [0, 102, 130];
  const GRAY = [100, 100, 100];

  function setColor(rgb) {
    doc.setTextColor(rgb[0], rgb[1], rgb[2]);
  }

  function text(str, x, y, opts = {}) {
    if (str === undefined || str === null || str === "") return;
    const { size = 9, style = "normal", color = BLACK, align = "left" } = opts;
    setColor(color);
    doc.setFontSize(size);
    doc.setFont("helvetica", style);
    doc.text(String(str), x, y, { align });
  }

  function multiText(str, x, y, opts = {}) {
    if (!str) return y;
    const {
      size = 9,
      style = "normal",
      color = BLACK,
      maxW = 182,
      lineH = 5,
    } = opts;
    setColor(color);
    doc.setFontSize(size);
    doc.setFont("helvetica", style);
    const lines = doc.splitTextToSize(String(str), maxW);
    lines.forEach((line, i) => doc.text(line, x, y + i * lineH));
    return y + lines.length * lineH;
  }

  // ── Date and Invoice No ──
  text(formatDate(date), marginL + 9, 38, {
    size: 9,
    style: "bold",
    color: BLACK,
  });
  text(invoiceNumber, marginL + 18, 42, {
    size: 9,
    style: "bold",
    color: BLACK,
  });

  // ── Bill To ──
  let curY = 56;
  if (billTo.name) {
    text(billTo.name, marginL, curY, { size: 9, style: "bold", color: BLACK });
    curY += 5;
  }
  if (billTo.company) {
    text(billTo.company, marginL, curY, {
      size: 9,
      style: "bold",
      color: DARK_BLUE,
    });
    curY += 5;
  }
  if (billTo.address) {
    curY = multiText(billTo.address, marginL, curY, {
      size: 9,
      color: BLACK,
      maxW: 90,
      lineH: 4,
    });
  }

  const gstLabelY = 75;
  const panLabelY = 79;
  if (billTo.gstNumber) {
    text(billTo.gstNumber, marginL + 25, gstLabelY, {
      size: 9,
      style: "bold",
      color: BLACK,
    });
  }
  const panValue = billTo.pan || pan;
  if (panValue) {
    text(panValue, marginL + 15, panLabelY, {
      size: 9,
      style: "bold",
      color: BLACK,
    });
  }

  function formatMonthYear(d) {
    if (!d) return "";
    const dt = new Date(d);
    if (isNaN(dt.getTime())) return "";
    return dt.toLocaleDateString("en-IN", { month: "long", year: "numeric" });
  }
  const monthValue = formatMonthYear(date);
  text(monthValue, marginL + 135, panLabelY + 9, {
    size: 9,
    style: "bold",
    color: BLACK,
  });
  // if (advertisingType) {
  //   text(advertisingType, marginL + 135, panLabelY + 14, {
  //     size: 9,
  //     style: "bold",
  //     color: BLACK,
  //   });
  // }

  // ── Table ──
  const colX = [24, 75, 92, 107, 123, 143, 157, 165, 175];
  const colW = [50, 16, 22, 18, 18, 18, 13, 16, 21];
  const tableHeaderBottomY = 114;
  const rowH = 10;

  const tableItems = items.length > 0 ? items : [{}];

  tableItems.forEach((item, idx) => {
    const ry = tableHeaderBottomY + idx * rowH;

    // ── Publication column: show publication, advertisingType, dop ──
    const pubLines = [];
    if (item.publication) pubLines.push(item.publication);
    if (advertisingType) pubLines.push(`on ${advertisingType}`);
    if (item.dop) pubLines.push(`(DOP: ${formatDate(item.dop)})`);

    // Draw each line in the first column with smaller font, stacked
    const startY = ry + rowH / 2 - (pubLines.length - 1) * 1.8;
    pubLines.forEach((line, li) => {
      setColor(BLACK);
      doc.setFontSize(8);
      doc.setFont("helvetica", "normal");
      const lines = doc.splitTextToSize(line, colW[0] - 4);
      doc.text(lines[0] ?? "", colX[0] + 2, startY + li * 3.6);
    });

    const axisDetails = invoiceData.axisBankDetails || {};

    const otherData = [
      { value: axisDetails.city || "-", colIdx: 1 },
      { value: axisDetails.product || "-", colIdx: 2 },
      {
        value: axisDetails.typesOfLegalAuction || "",
        colIdx: 3,
      },
      {
        value: axisDetails.natureOfExpenses || "",
        colIdx: 4,
      },
      {
        value: axisDetails.courtCaseNumber || "",
        colIdx: 5,
      },
      {
        value:
          axisDetails.noOfCases != null
            ? String(axisDetails.noOfCases)
            : item.acc != null
              ? String(item.acc)
              : item.noOfCases != null
                ? String(item.noOfCases)
                : "",
        colIdx: 6,
      },
      {
        value:
          axisDetails.ratePerCase != null
            ? fmt(axisDetails.ratePerCase)
            : item.perAcc != null
              ? fmt(item.perAcc)
              : item.ratePerCase != null
                ? fmt(item.ratePerCase)
                : "",
        colIdx: 7,
      },
      {
        value:
          axisDetails.amount != null
            ? fmt(axisDetails.amount)
            : item.amount != null
              ? fmt(item.amount)
              : "",
        colIdx: 8,
      },
    ];
    otherData.forEach(({ value, colIdx }) => {
      if (!value) return;
      const isNumeric = colIdx >= 7;
      setColor(BLACK);

      // Multi‑line for columns 3 and 4
      if (colIdx === 3 || colIdx === 4) {
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        const lines = doc.splitTextToSize(value, colW[colIdx] - 4);
        const lineHeight = 3.5;
        const startY = ry + 4; // top padding
        lines.forEach((line, li) => {
          doc.text(line, colX[colIdx] + 2, startY + li * lineHeight);
        });
      } else {
        doc.setFontSize(7.5);
        doc.setFont("helvetica", "normal");
        if (isNumeric) {
          doc.text(
            value,
            colX[colIdx] + colW[colIdx] - 2,
            ry + rowH / 2 + 1.5,
            {
              align: "right",
            },
          );
        } else {
          const lines = doc.splitTextToSize(value, colW[colIdx] - 3);
          doc.text(lines[0] ?? "", colX[colIdx] + 2, ry + rowH / 2 + 1.5);
        }
      }
    });
  });

  // ── Totals ──
  const totalsStartY = tableHeaderBottomY + tableItems.length * rowH;
  const totRowH = 7;
  const valueX = pageW - marginL - 2;

  // WITH THIS:
  const axisDetails = invoiceData.axisBankDetails || {};
  const displaySubTotal =
    axisDetails.amount != null ? axisDetails.amount : subTotal;
  const displayCgst = axisDetails.cgst != null ? axisDetails.cgst : cgstAmount;
  const displaySgst = axisDetails.sgst != null ? axisDetails.sgst : sgstAmount;
  const displayTotal =
    axisDetails.totalAmount != null ? axisDetails.totalAmount : totalAmount;

  text(fmt(displaySubTotal), valueX, totalsStartY + totRowH * 0.6, {
    size: 8.5,
    color: BLACK,
    align: "right",
  });
  text(fmt(displayCgst), valueX, totalsStartY + totRowH * 1.3, {
    size: 8.5,
    color: BLACK,
    align: "right",
  });
  text(fmt(displaySgst), valueX, totalsStartY + totRowH * 1.9, {
    size: 8.5,
    color: BLACK,
    align: "right",
  });
  text(fmt(displayTotal), valueX, totalsStartY + totRowH * 2.5, {
    size: 8.5,
    style: "bold",
    color: DARK_BLUE,
    align: "right",
  });

  // ── Amount in words ──
  const amtWordsY = totalsStartY + totRowH * 5 + 2;
  text(amtWords, marginL + 26, amtWordsY, {
    size: 9,
    style: "bold",
    color: BLACK,
  });

  // ── Save ──
  const fname = `AxisInvoice_${(invoiceNumber || "draft").replace(/\//g, "-")}.pdf`;
  doc.save(fname);
}
